function r(e, n) {
  return typeof e != "string" || typeof n != "string" || e.length !== 1 || n.length < 1 ? !1 : n.indexOf(e) >= 0;
}
function p(e) {
  return typeof e == "string" && e.length > 0;
}
function E(...e) {
  return e.reduce(
    (n, i) => {
      const f = [];
      for (const c of n)
        for (const t of i)
          f.push([...c, t]);
      return f;
    },
    [[]]
  );
}
function m(e) {
  if (!p(e))
    return e;
  let n = "";
  for (let i = 0; i < e.length; i++)
    r(e[i], "άἀἁἂἃἄἅἆἇὰάᾀᾁᾂᾃᾄᾅᾆᾇᾰᾱᾲᾳᾴᾶᾷ") ? n += "α" : r(e[i], "ΆἈἉἊἋἌἍἎἏᾈᾉᾊᾋᾌᾍᾎᾏᾸᾹᾺΆᾼ") ? n += "Α" : r(e[i], "έἐἑἒἓἔἕὲέ") ? n += "ε" : r(e[i], "ΈἘἙἚἛἜἝ") ? n += "Ε" : r(e[i], "ήἠἡἢἣἤἥἦἧῆὴῇ") ? n += "η" : r(e[i], "ΉἨἩἪἫἬἭἮἯ") ? n += "Η" : r(e[i], "ίἰἱἲἳἴἵὶῖ") ? n += "ι" : r(e[i], "ΊἶἷἸἹἺἻἼἽἾἿ") ? n += "Ι" : r(e[i], "όὀὁὂὃὄὅὸ") ? n += "ο" : r(e[i], "ΌὈὉὊὋὌὍ") ? n += "Ο" : r(e[i], "ύὐὑὒὓὔὕὖὗ") ? n += "υ" : r(e[i], "ΎὙὛὝὟ") ? n += "Υ" : r(e[i], "ώὠὡὢὣὤὥὦὧῶ") ? n += "ω" : r(e[i], "ΏὨὩὪὫὬὭὮὯ") ? n += "Ω" : n += e[i];
  return n;
}
function h(e) {
  if (!p(e))
    return e;
  let n = "";
  for (let i = 0; i < e.length; i++)
    r(
      e[i],
      "άἀἁἂἃἄἅἆἇὰάᾀᾁᾂᾃᾄᾅᾆᾇᾰᾱᾲᾳᾴᾶᾷΆἈἉἊἋἌἍἎἏᾈᾉᾊᾋᾌᾍᾎᾏᾸᾹᾺΆᾼ"
    ) ? n += "α" : r(e[i], "έἐἑἒἓἔἕὲέΈἘἙἚἛἜἝ") ? n += "ε" : r(e[i], "ήἠἡἢἣἤἥἦἧῆὴῇΉἨἩἪἫἬἭἮἯ") ? n += "η" : r(e[i], "ίἰἱἲἳἴἵὶῖΊἶἷἸἹἺἻἼἽἾἿ") ? n += "ι" : r(e[i], "όὀὁὂὃὄὅὸΌὈὉὊὋὌὍ") ? n += "ο" : r(e[i], "ύὐὑὒὓὔὕὖὗΎὙὛὝὟ") ? n += "υ" : r(e[i], "ώὠὡὢὣὤὥὦὧῶΏὨὩὪὫὬὭὮὯ") ? n += "ω" : n += e[i].toLowerCase();
  return n;
}
const d = {
  αι: ["ai", "e"],
  ει: ["ei", "i"],
  οι: ["oi", "i"],
  ου: ["ou", "oy", "u"],
  ευ: ["eu", "ef", "ev", "ey"],
  αυ: ["au", "af", "av", "ay"],
  μπ: ["mp", "b"],
  γγ: ["gg", "g"],
  γκ: ["gk", "g"],
  ντ: ["nt", "d"]
}, O = {
  α: "a",
  β: "b",
  γ: "g",
  δ: "d",
  ε: "e",
  ζ: "z",
  η: "h",
  θ: "th",
  ι: "i",
  κ: "k",
  λ: "l",
  μ: "m",
  ν: "n",
  ξ: "x",
  ο: "o",
  π: "p",
  ρ: "r",
  σ: "s",
  ς: "s",
  τ: "t",
  υ: "u",
  φ: "f",
  χ: "x",
  ψ: "ps",
  ω: "w"
}, y = {
  β: ["b", "v"],
  η: ["h", "i"],
  θ: ["th", "8"],
  ξ: ["ks", "x"],
  υ: ["y", "u", "i"],
  φ: ["f", "ph"],
  χ: ["x", "h", "ch"],
  ω: ["w", "o", "v"]
}, w = m, N = h;
function A(e) {
  if (!p(e))
    return [e];
  let n = [], i = [];
  const f = h(e);
  let c = f, t = [], g = [];
  for (const o in d) {
    const s = o, a = f.indexOf(s);
    let l = [];
    a >= 0 && (d[s].forEach((u) => {
      l = [...l, { find: s, replace: u }];
    }), t = [...t, l], c = c.replace(
      new RegExp(s, "g"),
      ""
    ));
  }
  for (const o in y) {
    const s = o, a = c.indexOf(s);
    let l = [];
    a >= 0 && (y[s].forEach((u) => {
      l = [...l, { find: s, replace: u }];
    }), g = [...g, l]);
  }
  return i = E(...t, ...g), i && i.length > 0 && (n = i.map((o) => {
    let s = f;
    return Array.isArray(o) ? o.forEach(
      (a) => s = s.replace(
        new RegExp(a.find, "g"),
        a.replace
      )
    ) : s = s.replace(new RegExp(o.find, "g"), o.replace), s;
  })), n.length === 0 && (n = [f]), n.map((o) => {
    const s = new Map(Object.entries(O));
    let a = "";
    for (const l of o) {
      const u = s.get(l);
      a += u ?? l;
    }
    return a;
  });
}
function z(e) {
  if (!p(e))
    return e;
  let n = "";
  for (const i of h(e)) {
    const f = O[i];
    n += typeof f == "string" ? f : i;
  }
  return n;
}
export {
  z as getGreeklish,
  A as getGreeklishVariants,
  w as getSanitizedDiacritics,
  N as getSanitizedDiacriticsLowercase
};
